import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/services/jwt.service";
import { API_URL } from "@/common/config";
import Swal from "sweetalert2";
/**
 * Service to call HTTP request via Axios
 */
const axiosGed = axios.create();
const ApiService = {
  init() {
    Vue.use(VueAxios, axiosGed);
    Vue.axios.defaults.baseURL = API_URL;

    Vue.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status == 401)
          Swal.fire({
            title: "Tempo de Acesso Expirado",
            text: "Você será redirecionado para a tela de Login em 5 segundos.",
            timer: 5000,
            allowOutsideClick: false,
            onOpen: function () {
              Swal.showLoading();
            },
          }).then(function (result) {
            if (result.dismiss === "timer") {
              JwtService.destroyToken();
              JwtService.destroyDateExpires();
              window.location.href =
                window.location.origin +
                "/" +
                JSON.parse(window.localStorage.getItem("cliente")).tagUrl;
            }
          });

        return Promise.reject(error);
      }
    );
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch((error) => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "", params = null) {
    return Vue.axios
      .get(`${resource}/${slug}`, { params: params })
      .catch((error) => {
        throw new Error(`[KT] ApiService ${error}`);
      });
  },

  /**
   * Send the Download HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  download(resource, slug = "") {
    return Vue.axios
      .get(`${resource}/${slug}`, { responseType: "blob" })
      .catch((error) => {
        throw new Error(`[KT] ApiService ${error}`);
      });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  postFormData(resource, params) {
    Vue.axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

    return Vue.axios.post(`${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params = null, config = {}) {
    return Vue.axios.put(`${resource}`, params, config);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  patch(resource, params = null) {
    return Vue.axios.patch(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch((error) => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
};

export default ApiService;
